import appSyncClient from '../appsync/client';
import createUser from '../appsync/mutations/CreateUser';

export default ({ user, language }) => {
  const timestamp = new Date().toString();
  if (!user?.profile?.email || !user?.profile?.agreement) return Promise.resolve();
  return appSyncClient
    .mutate({
      mutation: createUser(
        user.profile.email,
        !!user.profile.agreement.allowResearch,
        timestamp,
        !!user.profile.agreement.agreedToTerms,
        user.profile.agreement.notShownAgreement || true,
        language,
      ),
    });
};
